/**
 * Who the product says it is.
 *
 * "Lagoon" is the codename (plan decision CD10): the commercial name arrives
 * later, and when it does the rename must be a configuration change and a copy
 * pass, not a grep across five services. Every user-visible mention of the
 * product, the address people write to for help, and the entity that owns it
 * comes from here, threaded through `LagoonEnv.branding`.
 *
 * This file is the one place those literals are allowed to appear. The guard in
 * `no-brand-literals.test.ts` fails the build if they reappear anywhere else in
 * `apps/` or `packages/`, which is what keeps the promise above true rather
 * than aspirational.
 *
 * No imports, on purpose: the browser bundles reach this through the
 * `@lagoon/config/branding` subpath, and it must not drag zod or `node:*` in
 * with it.
 */
/**
 * The defaults, so nothing needs an app setting to boot.
 *
 * Dev and CI run on these; an environment that wants the commercial name sets
 * the three variables and changes nothing else.
 */
export const DEFAULT_BRANDING = Object.freeze({
    productName: "Lagoon",
    supportEmail: "support@blackpearl.com",
    legalEntity: "Black Pearl Group",
});
//# sourceMappingURL=branding.js.map